class UploadAdapter {
  constructor( loader ) {
    this.loader = loader;
  }

  upload() {
    return this.loader.file
      .then( file => new Promise( ( resolve, reject ) => {
        this._initRequest();
        this._initListeners( resolve, reject, file );
        this._sendRequest( file );
      } ) );
  }

  abort() {
    if ( this.xhr ) {
      this.xhr.abort();
    }
  }

  _initRequest() {
    const xhr = this.xhr = new XMLHttpRequest();
    const token = document.querySelector('meta[name="csrf-token"]').content;

    xhr.open( 'POST', '/api/v1/wysiwyg_image', true );
    xhr.setRequestHeader('X-CSRF-Token', token);
    xhr.responseType = 'json';
  }

  _initListeners( resolve, reject, file ) {
    if (file.size > 5242880) {
      return reject( 'ファイルアップロードに失敗しました 5MBを超えるものはアップロードできません');
    }
    const xhr = this.xhr;
    const loader = this.loader;
    const genericErrorText = `ファイルアップロードに失敗しました ファイル名: ${ file.name }`;

    xhr.addEventListener( 'error', () => reject( genericErrorText ) );
    xhr.addEventListener( 'abort', () => reject() );
    xhr.addEventListener( 'load', () => {
      const response = xhr.response;

      if ( !response || response.error ) {
        return reject( response && response.error ? response.error.message : genericErrorText );
      }

      resolve( {
        default: response.url
      } );
    } );

    if ( xhr.upload ) {
      xhr.upload.addEventListener( 'progress', evt => {
        if ( evt.lengthComputable ) {
          loader.uploadTotal = evt.total;
          loader.uploaded = evt.loaded;
        }
      } );
    }
  }

  _sendRequest( file ) {
    const formData = new FormData();
    formData.append( 'wysiwyg_image[image]', file );

    this.xhr.send(formData);
  }
}

export default function CustomUploadAdapterPlugin( editor ) {
  editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
    return new UploadAdapter( loader );
  };
}
